import { render, staticRenderFns } from "./ModalConsultaProdutoCadastroEssencial.vue?vue&type=template&id=bece5682"
import script from "./ModalConsultaProdutoCadastroEssencial.vue?vue&type=script&lang=js"
export * from "./ModalConsultaProdutoCadastroEssencial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports